// NAV-1: dashboard → authoritative source destinations. One place, testable; each target must be a registered App.js route.
const isoDaysAgo = (days, now = new Date()) => new Date(now.getTime() - days * 86400000).toISOString().slice(0, 10);

export const DASHBOARD_TARGETS = {
  openShifts: () => '/roster/scheduling-board',
  pendingTimesheets: () => '/timesheets/pending?status=SUBMITTED',
  incidentsWeek: (now) => `/compliance/incidents?tab=list&from=${isoDaysAgo(7, now)}`,
  criticalAlerts: () => '/alerts?severity=CRITICAL',
  activeParticipants: () => '/participants/list?status=ACTIVE',
  activeStaff: () => '/staff/list',
  rosterFillRate: () => '/roster/scheduling-board',
  medicationMisses: () => '/clinical/medications?status=MISSED',
  claimsPending: () => '/finance/claims',
  payrollCost: () => '/admin/payroll',
  revenueEstimate: () => '/finance/invoices',
  marginEstimate: () => '/dashboard/finance',
  recommendations: () => '/insights/recommendations',
  riskOverview: () => '/insights/risk',
  aiCopilot: () => '/ai',
  alerts: () => '/alerts',
};

/** Path part only (for route-existence tests). */
export const targetPath = (href) => href.split('?')[0];
